import axios from "axios";
import {
  getApiBaseUrl,
  getAppUserId,
  getAppUserName,
} from "../env";
import { messagesStore } from "../store/Messages";
import { MessageTypes } from "../enums/MessageTypes";
import { ResponseStatuses } from "../enums/ResponseStatuses";
import { settingsGl } from "../store/Settings";
import { getVisitorPostBody } from "./webTrack";

export class QueryService {
  private static userId = null;
  /**
   * POST запрос на сервер
   * @param url
   * @param data
   */
  public static async postQuery<T = any>(url: string, data: {}) {
    try {
      await this.checkUserStat();
      const resp = await axios.post(getApiBaseUrl() + url, {
        ...data,
        tgId: getAppUserId(),
        userName: getAppUserName(),
      });
      /**
       * Обрабатываем ошибку от сервера. Причина неизвестна, необработанный exception
       */
      if (resp.data.type === ResponseStatuses.error) {
        messagesStore.add({
          text: resp.data.message,
          durationMs: 30000,
          type: MessageTypes.error,
        });
      }
      /**
       * Обрабатываем успешный запрос от сервера. Сообщение сформировано приложением
       */
      if (resp.data.type === ResponseStatuses.ok && resp.data.message) {
        messagesStore.add({
          text: resp.data.message,
          durationMs: 30000,
          type: MessageTypes.ok,
        });
      }

      return resp;
    } catch (e) {
      messagesStore.add({
        text: "Неизвестная ошибка, свяжитесь с администратором или попробуйте позже",
        durationMs: 30000,
        type: MessageTypes.error,
      });
    }
  }
  /**
   * Статистика
   * @returns
   */
  private static async checkUserStat() {
    if (this.userId) return;
    const res = await axios.post(getApiBaseUrl() + "/api/user/stat", {
      tgId: getAppUserId(),
      userName: getAppUserName(),
    });
    const { userId, informed } = res.data;
    this.userId = userId;
    settingsGl.informed = informed;
  }

  /**
   * POST для публичной афиши (visitorId и параметры в body).
   */
  public static async postAfishaQuery(
    url: string,
    data: Record<string, unknown> = {},
  ) {
    try {
      const resp = await axios.post(getApiBaseUrl() + url, {
        ...data,
        ...getVisitorPostBody(),
      });
      if (resp.data.type === ResponseStatuses.error) {
        messagesStore.add({
          text: resp.data.message,
          durationMs: 30000,
          type: MessageTypes.error,
        });
      }

      return resp;
    } catch (e) {
      messagesStore.add({
        text: "Неизвестная ошибка, свяжитесь с администратором или попробуйте позже",
        durationMs: 30000,
        type: MessageTypes.error,
      });
    }
  }

  /**
   * Get запрос на сервер
   * @param url
   */
  public static async getQuery(url: string) {
    try {
      console.log(url);
      const resp = await axios.get(getApiBaseUrl() + url);
      if (resp.data.type === ResponseStatuses.error) {
        messagesStore.add({
          text: resp.data.message,
          durationMs: 30000,
          type: MessageTypes.error,
        });
      }

      return resp;
    } catch (e) {
      messagesStore.add({
        text: "Неизвестная ошибка, свяжитесь с администратором или попробуйте позже",
        durationMs: 30000,
        type: MessageTypes.error,
      });
    }
  }

  /**
   * Вернуть текущи адрес сервера
   */
  public static getServerUri() {
    return getApiBaseUrl();
  }
}
